import { filter, fromEvent, iif, map, Observable, tap } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IpcService {
  private readonly message$ = fromEvent<MessageEvent<{ type: string; payload: unknown }>>(window, 'message');

  constructor() {}

  send<T>(messageType: string, payload: T, origin: string = '*'): void {
    window.postMessage({ type: messageType, payload }, origin);
  }

  sendToOpener<T>(messageType: string, payload: T, origin: string = '/'): void {
    if (!window.opener) {
      return;
    }

    window.opener.postMessage({ type: messageType, payload }, origin);
  }

  listen<T>(messageType: string, origin = '*'): Observable<T> {
    return this.message$.pipe(
      filter((event) => event.data.type === messageType),
      tap((event) => console.log('listen', event, origin, event.origin)),
      filter((event) => origin === '*' || event.origin === origin),
      map((event) => event.data.payload as T)
    );
  }
}
